export const LegalPageTab = {
  TermsAndConditions: 'terms-and-conditions',
  PrivacyPolicy: 'privacy-policy',
  Cookies: 'cookies',
  FAQs: 'FAQs',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type LegalPageTab = (typeof LegalPageTab)[keyof typeof LegalPageTab];
